/**
 * WWindowBanner - polskie tłumaczenia (okno banerowe).
 *
 * Treść bannerów (obrazy/HTML) pochodzi z backendu (admin edytuje w IADMIN).
 * Tu tylko stringi chrome widgetu (a11y / stan pusty).
 */
import type { DeepString } from "@/lib/i18n";

export const pl = {
  empty: "Brak banerów do wyświetlenia.",
  /** `goToSlide(2)` -> "Przejdź do baneru 2". */
  goToSlide: (index: number): string => `Przejdź do baneru ${index}`,
  bannerAlt: "Banner",
  close: "Zamknij",
} as const;

export type WWindowBannerTranslations = DeepString<typeof pl>;
